@if (!widget.isSelected) {
<button
  mat-stroked-button
  matTooltip="{{ widget.title | translate }}"
  [matTooltipPosition]="'after'"
  class="py-1 menu-widget-item w-100 mb-3"
  (click)="addOrRemoveWidget(widget)"
  (mouseenter)="showIcon = true"
  (mouseleave)="showIcon = false"
  [disabled]="isDisabled"
>
  <div class="button-content">
    <div class="static-icons">
      <mat-icon class="mr-2"> {{ widget.icon }} </mat-icon>
      <span class="widget-title">{{ widget.title | translate }}</span>
    </div>
    <div class="dynamic-icons">
      <div class="size-icon">
        @switch (widget.size) { @case (WIDGET_SIZES.SMALL) {
        <mat-icon [hidden]="showIcon || isDisabled" class="remove-icon"
          ><svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M10 0C4.47714 0 0 4.47714 0 10V14C0 19.5229 4.47714 24 10 24H14C19.5229 24 24 19.5229 24 14V10C24 4.47714 19.5229 0 14 0H10ZM10.639 17.039C11.003 17.1517 11.3843 17.208 11.783 17.208C12.147 17.208 12.5197 17.1517 12.901 17.039C13.2823 16.9263 13.6247 16.7573 13.928 16.532C14.2313 16.3067 14.4783 16.0207 14.669 15.674C14.8683 15.3187 14.968 14.8983 14.968 14.413C14.968 14.023 14.9073 13.6807 14.786 13.386C14.6733 13.0827 14.5043 12.814 14.279 12.58C14.0623 12.346 13.798 12.1467 13.486 11.982C13.1827 11.8087 12.8447 11.657 12.472 11.527L11.887 11.332C11.3583 11.15 10.9727 10.9637 10.73 10.773C10.4873 10.5737 10.366 10.3353 10.366 10.058C10.366 9.772 10.4917 9.54233 10.743 9.36899C10.9943 9.18701 11.3107 9.09601 11.692 9.09601C12.0907 9.09601 12.4027 9.20001 12.628 9.40799C12.862 9.616 13.0223 9.85001 13.109 10.11L14.656 9.45999C14.5867 9.25201 14.4783 9.03101 14.331 8.797C14.1837 8.56299 13.9887 8.35068 13.746 8.16C13.512 7.96066 13.2217 7.80032 12.875 7.67899C12.537 7.54901 12.134 7.48401 11.666 7.48401C11.2153 7.48401 10.8037 7.55334 10.431 7.69199C10.067 7.82199 9.75067 8.00833 9.48199 8.25101C9.22198 8.48499 9.01834 8.76233 8.871 9.08301C8.73233 9.39499 8.66299 9.733 8.66299 10.097C8.66299 10.4523 8.728 10.773 8.858 11.059C8.99667 11.3363 9.17001 11.579 9.37799 11.787C9.586 11.995 9.81567 12.1727 10.067 12.32C10.327 12.4673 10.5827 12.5843 10.834 12.671L11.406 12.879C11.744 13.0003 12.0257 13.1173 12.251 13.23C12.485 13.3427 12.6713 13.4597 12.81 13.581C12.9573 13.7023 13.0613 13.8323 13.122 13.971C13.1827 14.1097 13.213 14.2657 13.213 14.439C13.213 14.621 13.174 14.7813 13.096 14.92C13.018 15.0587 12.9097 15.1757 12.771 15.271C12.641 15.3577 12.4893 15.427 12.316 15.479C12.1513 15.5223 11.978 15.544 11.796 15.544C11.302 15.544 10.9033 15.3923 10.6 15.089C10.2967 14.777 10.0843 14.387 9.96301 13.919L8.31201 14.569C8.44199 15.0023 8.61966 15.3837 8.845 15.713C9.07034 16.0337 9.33466 16.3067 9.638 16.532C9.94135 16.7573 10.275 16.9263 10.639 17.039Z"
              fill="var(--mat-primary)"
            />
            >
          </svg></mat-icon
        >
        } @case (WIDGET_SIZES.MEDIUM) {
        <mat-icon [hidden]="showIcon || isDisabled" class="remove-icon"
          ><svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M10 0C4.47714 0 0 4.47714 0 10V14C0 19.5229 4.47714 24 10 24H14C19.5229 24 24 19.5229 24 14V10C24 4.47714 19.5229 0 14 0H10ZM8.59177 7.69199H6.86276V17H8.59177V12.411L8.48776 10.851H8.59177L10.9708 15.024H12.0238L14.3898 10.851H14.4937L14.3898 12.411V17H16.1317V7.69199H14.3898L11.5428 12.619H11.4388L8.59177 7.69199Z"
              fill="var(--mat-primary)"
            />
            >
          </svg></mat-icon
        >
        } @case (WIDGET_SIZES.LARGE) {
        <mat-icon [hidden]="showIcon || isDisabled" class="remove-icon"
          ><svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M10 0C4.47714 0 0 4.47714 0 10V14C0 19.5229 4.47714 24 10 24H14C19.5229 24 24 19.5229 24 14V10C24 4.47714 19.5229 0 14 0H10ZM10.7188 7.69199H8.96384V17H14.6578V15.336H10.7188V7.69199Z"
              fill="var(--mat-primary)"
            />
            >
          </svg></mat-icon
        >
        } }
      </div>
      @if (!widget.isSelected) {
      <div>
        <mat-icon class="add-icon" [hidden]="!showIcon || isDisabled"
          >add_circle</mat-icon
        >
      </div>
      }
    </div>
  </div>
</button>
} @if (widget.isSelected) {
<button
  color="primary"
  mat-flat-button
  matTooltip="{{ widget.title | translate }}"
  [matTooltipPosition]="'after'"
  class="py-1 menu-widget-item w-100 mb-3"
  (click)="addOrRemoveWidget(widget)"
  (mouseenter)="showIcon = true"
  (mouseleave)="showIcon = false"
  [disabled]="isDisabled"
>
  <div class="button-content">
    <div class="static-icons">
      <mat-icon class="mr-2"> {{ widget.icon }} </mat-icon>
      <span class="widget-title">{{ widget.title | translate }}</span>
    </div>
    <div class="dynamic-icons">
      <div class="size-icon">
        @switch (widget.size) { @case (WIDGET_SIZES.SMALL) {
        <mat-icon [hidden]="showIcon" class="remove-icon"
          ><img
            src="../../../../../assets/icons/widgets/small_grey.svg"
            alt="size-icon"
        /></mat-icon>
        } @case (WIDGET_SIZES.MEDIUM) {
        <mat-icon [hidden]="showIcon" class="remove-icon"
          ><img
            src="../../../../../assets/icons/widgets/medium_grey.svg"
            alt="size-icon"
        /></mat-icon>
        } @case (WIDGET_SIZES.LARGE) {
        <mat-icon [hidden]="showIcon" class="remove-icon"
          ><img
            src="../../../../../assets/icons/widgets/large_grey.svg"
            alt="size-icon"
        /></mat-icon>
        } }
      </div>
      @if (widget.isSelected) {
      <div>
        <mat-icon class="remove-icon" [hidden]="!showIcon">
          remove_circle
        </mat-icon>
      </div>
      }
    </div>
  </div>
</button>
}
